module.exports = __webpack_public_path__ + "img/solution-electric-function-icon-3.f37dfedc.svg";